import * as React from 'react';
export var useUniqID = function (defaultId) {
    var idRef = React.useRef(null);
    if (idRef.current === null) {
        if (defaultId) {
            idRef.current = defaultId;
        }
        else {
            idRef.current = "".concat(Math.random());
        }
    }
    return idRef.current;
};
//# sourceMappingURL=useUniqId.js.map